import axios from "axios";
import { postRequest } from "../utils/axiosHandler";

export const onePayCheckout = async (onePayData, token) => {
  //console.log("OnePay Data:", onePayData);
 // console.log("Token:", token);
  try {
    const response = await axios.post("https://api.onepay.lk/v3/checkout/link/", onePayData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${token}`, // Include Bearer Token
      },
    });
  //  console.log("OnePay API Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("OnePay API Error:", error);
    throw error;
  }
};



export const onePayCheckStatus = async () => {
  // Retrieve the transaction ID from sessionStorage
  const onePayTransactionId = sessionStorage.getItem("onePayTransactionId");
  const orderId = sessionStorage.getItem("orderId");
  
  try {
    // Make the POST request to your backend endpoint 
    // (which in turn calls "/onepay/check-status")
    const response = await postRequest("/onepay/check-status", { onePayTransactionId, orderId });
    return response;
  } catch (error) {
    console.error("OnePay Check Status Error:", error);
    throw error;
  }
};
